import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import {
  SettingsListStyled,
  ItemButton,
  StyledItemText,
  StyledItemIcon,
} from './styles/SettingsListStyled';

class SettingsLine extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { title, current, value, onClick } = this.props;

    return (
      <SettingsListStyled>
        <ItemButton onClick={onClick}>
          <StyledItemText
            color={value === current ? 'blue_smalt' : 'white'}
            type="capitalize"
            font="din_medium"
            size="fs_s"
            fixedSize
          >
            {title}
            &nbsp;
          </StyledItemText>
          {value === current && <StyledItemIcon name="check" color="blue_smalt" size={16} />}
        </ItemButton>
      </SettingsListStyled>
    );
  }
}

SettingsLine.propTypes = {
  current: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  onClick: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

SettingsLine.defaultProps = {
  current: null,
  onClick: Function.prototype,
  title: '',
  value: null,
};

export default SettingsLine;
